import styled from "styled-components";


const Loader = styled.div`
  border-radius: 50%;
  width: 4.3em;
  height: 4.3em;
  margin: 60px auto;
  font-size: 10px;
  text-indent: -9999em;
  border-left: 0.5em solid #C41230;
  animation: load 1.1s infinite linear;
  &:after {
    border-radius: 50%;
    width: 5em;
    height: 5em;
  }

  @keyframes load {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export default Loader
